import React from 'react'
import { CoinIcon, FormattedCurrency, FormattedHTMLMessage, Input } from '@web/walter-ui-kit'

import { useIntl } from 'react-intl'
import { GetProducts } from '@web/walter-lib/api'
import cn from 'classnames'
import s from './s.module.css'
import { lang } from './lang'
import { useWalletByCurrency } from '~hooks/useWalletByCurrency'
import AddFunds from '~pages/CardsPage/components/AddFunds'

interface Props {
    data: GetProducts
    isBalanceError: boolean
}

function CurrencyInput({ data, isBalanceError }: Props) {
    const intl = useIntl()

    const { data: balance, isLoading } = useWalletByCurrency(data.currency)

    if (!data.currency || isLoading) {
        return null
    }

    return (
        <Input
            label={intl.formatMessage(lang.currencyForPayment)}
            value={data.currency}
            dataPointer="currency_input"
            prefix={<CoinIcon code={data.currency} size="xs" />}
            suffix={
                <div className={cn(isBalanceError && s.error)}>
                    <FormattedCurrency
                        maxPrecision={2}
                        value={balance}
                        currency={data.currency}
                        dataPointer="currency_input_amount"
                    />
                </div>
            }
            readOnly
            isInvalid={isBalanceError}
            description={
                isBalanceError ? (
                    <div className={s.less}>
                        <FormattedHTMLMessage {...lang.less} />
                        <AddFunds currency={data.currency} />
                    </div>
                ) : undefined
            }
        />
    )
}

export default CurrencyInput
